import {createSelector} from '@reduxjs/toolkit'

export const getLandingStats = state => state.landing.stats